import { styled } from '@mui/material/styles';

export const SceneImage = styled('img')(() => ({
  maxHeight: '200px',
  maxWidth: '200px',
  width: '80%',
}));
